<!-- src/components/ventas/view/VentaPOS/components/atoms/ZapiStockBadge.vue -->
<template>
  <div class="stock-badge" :class="claseBadge">    
    <span>{{ texto }}</span>
  </div>
</template>

<script>
export default {
  name: 'ZapiStockBadge',
  props: {
    stockActual: {
      type: Number,
      default: 0
    },
    stockMinimo: {
      type: Number,
      default: 0
    },
    disponible: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    claseBadge() {
      if (!this.disponible || this.stockActual <= 0) return 'badge-agotado'
      if (this.stockActual <= this.stockMinimo && this.stockMinimo > 0) return 'badge-bajo'
      return 'badge-disponible'
    },
    texto() {
      if (!this.disponible || this.stockActual <= 0) return 'AGOTADO'
      if (this.stockActual <= this.stockMinimo && this.stockMinimo > 0) {
        return `STOCK BAJO (${this.stockActual})`
      }
      return `Stock: ${this.stockActual}`
    },    
  }
}
</script>

<style scoped>
.stock-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.badge-disponible {
  background-color: #e6f7ec;
  color: #1e8a4c;
}

.badge-bajo {
  background-color: #fff3e0;
  color: #e65100;
  animation: pulse-bajo 2s infinite;
}

.badge-agotado {
  background-color: #fce4ec;
  color: #c62828;
}

@keyframes pulse-bajo {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}
</style>